import { createContext, useState } from "react";
import { URLS } from "../../configuration/urls";
import { ECAxiosAPI } from "@eclear-ag/ec-common-ui";

const APIContext = createContext();

const api_url = URLS.EC_SPOT_BE();

export const APIProvider = ({ children }) => {
  const [isSpotEmpty, setIsSpotEmpty] = useState(
    localStorage.getItem("isSpotEmpty")
  );

  const [currentSubscriptionView, setCurrentSubscriptionView] = useState({
    screen: "subscriptionsList",
    product: ""
  });

  const apiHeader = (headersObj) => {
    return {
      accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("getToken")}`,
      ...headersObj
    };
  };

  const getData = async (endPoint, headersObj, baseUrl) => {
    const headers = {
      accept: "*/*",
      ...headersObj
    };
    try {
      const res = await ECAxiosAPI.get(
        `${typeof baseUrl === "undefined" ? api_url : baseUrl}${endPoint}`,
        { headers }
      );
      return res;
    } catch (error) {
      errorHandler(endPoint, error);
      throw error?.response?.data?.message || error.response.status;
    }
  };

  const postData = async (endPoint, data, headersObj, baseUrl) => {
    const headers = {
      accept: "*/*",
      ...headersObj
    };
    try {
      const res = await ECAxiosAPI.post(
        `${typeof baseUrl === "undefined" ? api_url : baseUrl}${endPoint}`,
        data,
        { headers }
      );
      return res;
    } catch (error) {
      errorHandler(endPoint, error);
      return error.response.status;
    }
  };

  const updateData = async (endPoint, data, headersObj) => {
    const headers = {
      accept: "*/*",
      ...headersObj
    };
    try {
      const res = await ECAxiosAPI.put(`${api_url}${endPoint}`, data, {
        headers
      });
      return res === "" ? "success" : res;
    } catch (error) {
      errorHandler(endPoint, error);
    }
  };

  const deleteData = async (endPoint, headersObj) => {
    const headers = {
      accept: "*/*",
      ...headersObj
    };
    try {
      const res = await ECAxiosAPI.delete(`${api_url}${endPoint}`, { headers });
      return res;
    } catch (error) {
      errorHandler(endPoint, error);
    }
  };

  // helpers
  const errorHandler = (apiName, err) => {
    console.error(`${apiName} failed with: `, err.message);
    if (err.url) {
      return (window.location.href = err.url);
    }
  };

  function allowToSpecificDomain() {
    //following array cotains forbidden URLs list
    const urls = [
      "localhost",
      "dev.eclear-solutions.com",
      "acc.eclear-solutions.com",
      "ref.eclear-solutions.com",
      "eclear-solutions.com"
    ];
    for (let i = 0; i < urls.length; i++) {
      if (window.location.hostname.includes(urls[i])) {
        return true;
      }
    }
    return false;
  }

  return (
    <APIContext.Provider
      value={{
        getData,
        postData,
        updateData,
        deleteData,
        isSpotEmpty,
        setIsSpotEmpty,
        currentSubscriptionView,
        setCurrentSubscriptionView,
        apiHeader,
        allowToSpecificDomain
      }}
    >
      {children}
    </APIContext.Provider>
  );
};

export default APIContext;
